import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';
import { useState } from "react";

class Seccion03CooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeButton: null,
            page: 0
        };
    }

    getActiveButton = (isActive) => {
        return {
            outline: 'none',
            display: 'block',
            margin: 'auto',
            transition: 'transform 0.15s ease',
            transform: isActive ? 'scale(0.96)' : 'scale(1)',
            backgroundColor: 'transparent',
            border: 0
        };
    }

    scrollToStar = () => {
        const target = document.getElementById("seccion01");
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    handleTogglePage = () => {
        this.setState(prevState => ({
            page: prevState.page === 0 ? 1 : 0
        }));
    };

    render() {
        const { activeButton } = this.state;

        const items = [
            { texto: "Estar al día en aportes sociales:", puntos: 1000 },
            { texto: "Tener tus datos actualizados:", puntos: 100 },
            { texto: "Tener una llave asociada a una cuenta de ahorros de UTRAHUILCA en el sistema de pagos inmediatos BRE-B, a la fecha de corte de asignación de puntos (se asignarán 100 puntos por cada llave que cumpla este criterio):", puntos: 100 },
            {
                texto: "Antigüedad de vinculación por años",
                subitems: [
                    { texto: "- De 1 a 5 años:", puntos: 50 },
                    { texto: "- De 6 a 10 años:", puntos: 100 },
                    { texto: "- De 11 a 20 años:", puntos: 200 },
                    { texto: "- De 21 años en adelante:", puntos: 500 }
                ]
            },

            { texto: "Completar o mantener el equivalente a dos (2) SMMLV en tu cuenta de Aportes Sociales o Ahorro Permanente:", puntos: 500 },
            { texto: "Vincularte a UTRAHUILCA:", puntos: 100 },
            { texto: "Por reactivarte como asociado:", puntos: 200 },
        ];


        const { page } = this.state;

        const ITEMS_PER_PAGE = Math.ceil(items.length / 2);

        const visibleItems = items.slice(
            page * ITEMS_PER_PAGE,
            (page + 1) * ITEMS_PER_PAGE
        );

        return (
            <React.Fragment>
                <section className="planestimulos-sorteo-container " style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/FondoAzul.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                    <div className="planestimulos-contenido">
                        <div className="planestimulos-seccion">
                            <div className="titleContainer">
                                <h2 className="planestimulos-titulo" data-aos="flip-up" data-aos-delay="300">Así podrás acumular</h2>
                                <p data-aos="flip-down" data-aos-delay="300" className="planestimulos-titulo-segundario biggerv2" >puntos por</p>
                            </div>

                            <div className="planestimulos-sorteo-img">
                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/UnicaVez.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp" width='480px' />
                            </div>

                            <div className="planestimulos-sorteo-img">
                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/CadaAccion.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp" width="636px" height="115px" />
                            </div>
                        </div>

                        <div className="planestimulos-texto">
                            {visibleItems.map((item, i) => (
                                <div className="planestimulos-unica-vez" key={i}>
                                    <div className="planestimulos-unica-vez-row">
                                        <div className="planestimulos-item-left">
                                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/ItemBlanco.svg`} alt="icon" className="planestimulos-icon" />
                                            <p className="text itemsWrapper">{item.texto}</p>
                                        </div>

                                        {!item.subitems && (
                                            <span className="text planestimulos-puntos">
                                                {item.puntos} puntos
                                            </span>
                                        )}
                                    </div>

                                    {item.subitems && (
                                        <div className="planestimulos-subitems">
                                            {item.subitems.map((sub, idx) => (
                                                <div className="planestimulos-subitem" key={idx}>
                                                    <span className="text">{sub.texto}</span>
                                                    <span className="text planestimulos-puntos">{sub.puntos} puntos</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                </div>
                            ))}

                            <div className='planestimulos-btn-container planestimulos-adaptable'>
                                <button id="btnToggle" className="button-img" onClick={this.handleTogglePage} style={this.getActiveButton(activeButton === 0)} >
                                    <img data-aos="zoom-in" data-duration="900" data-aos-delay="300" src={ page === 0 ? `${URLImgFront}/assets/EstrategiasComerciales/BotonAvanzarNaranja.svg`:`${URLImgFront}/assets/EstrategiasComerciales/BotonAtrasNaranja.svg` } alt="toggle" style={{ width: '100%', height: '90px', touchAction: 'manipulation', maxWidth: '158px' }} />
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Seccion03CooperaGanaMas;